import styled from 'styled-components';
import bgImage from './bgImage.jpg';

const SignInStyleWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  background: url(${bgImage}) no-repeat center center;
  background-size: cover;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    z-index: 1;
    top: 0;
  }

  .isoLoginContentWrapper {
    width: 500px;
    height: 100%;
    overflow-y: auto;
    z-index: 10;
    position: relative;
  }

  .isoLoginContent {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 70px 50px;
    position: relative;
    background-color: #ffffff;

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 70px 20px;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 50px;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  .isoSignInForm {
    width: 100%;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;

    .isoInputWrapper {
      margin-bottom: 15px;

      &:last-of-type {
        margin-bottom: 0;
      }

      input {
        &::-webkit-input-placeholder {
          color: #bababa;
        }

        &:-moz-placeholder {
          color: #bababa;
        }

        &::-moz-placeholder {
          color: #bababa;
        }
        &:-ms-input-placeholder {
          color: #bababa;
        }
      }
    }

    .isoHelperWrapper {
      margin-top: 35px;
      flex-direction: column;
    }

    .isoForgotPass {
      font-size: 12px;
      color: #797979;
      margin-bottom: 10px;
      text-decoration: none;

      &:hover {
        color: #00598d;
      }
    }
  }
`;

export default SignInStyleWrapper;



// WEBPACK FOOTER //
// ./src/components/Login/login.style.js